<template>
  <div>
    <b-row>
      <b-col class="d-flex justify-content-between pb-1 align-items-center">
        <h1 class="font-weight-bolder">
          {{ $t('supplierTags') }}
        </h1>
        <b-button
          :to="{ name: 'new-supplier-tag' }"
          variant="primary"
        >
          {{ $t('register', { type: $t('supplierTags') }) }}
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <supplier-tags-table />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BButton } from 'bootstrap-vue'
import { mapActions } from 'vuex'
import SupplierTagsTable from '@/components/supplierTags/SupplierTagsTable.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    SupplierTagsTable,
  },
  mounted() {
    this.fetchSupplierTags({ by_active_status: null })
  },
  methods: {
    ...mapActions('supplierTags', ['fetchSupplierTags']),
  },
}
</script>

<style lang="scss" scoped></style>
